import { render, staticRenderFns } from "./PayFail.vue?vue&type=template&id=38f076d3&scoped=true&"
import script from "./PayFail.vue?vue&type=script&lang=js&"
export * from "./PayFail.vue?vue&type=script&lang=js&"
import style0 from "./PayFail.vue?vue&type=style&index=0&id=38f076d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f076d3",
  null
  
)

export default component.exports